import Swal from "sweetalert2";

/**
 * Utility function to show a SweetAlert2 dialog with automatic theme detection
 * @param {Object} options - SweetAlert2 options
 * @param {boolean} isDarkMode - Current theme mode (true for dark, false for light)
 * @returns {Promise} - SweetAlert2 promise
 */
export const showAlert = (options, isDarkMode) => {
  return Swal.fire({
    ...options,
    theme: isDarkMode ? "dark" : "light",
  });
};

/**
 * Creates a SweetAlert2 wrapper that automatically applies the current theme
 * @param {boolean} isDarkMode - Current theme mode (true for dark, false for light)
 * @returns {Object} - SweetAlert2 wrapper with theme support
 */
export const createThemedSwal = (isDarkMode) => {
  return {
    fire: (options, ...rest) => {
      // Handle both object notation and parameter notation
      if (typeof options === "object") {
        return showAlert(options, isDarkMode);
      } else {
        // Support for Swal.fire(title, text, icon) syntax
        return showAlert(
          {
            title: options,
            text: rest[0],
            icon: rest[1],
            ...(rest[2] || {}),
          },
          isDarkMode,
        );
      }
    },
    // Add other SweetAlert2 methods as needed
    mixin: Swal.mixin,
    isVisible: Swal.isVisible,
    close: Swal.close,
  };
};

export default createThemedSwal;
